import React, { useCallback } from 'react'
import Loading from '../../components/common/Loading'
import { exerciseDetail } from '../../constant/path'
import { useRouter } from '../../utils/helper'
import { useGetEClaimHistoryById } from '../../services/e-claim/e-claim-query'
import { UserClaimDocumentList, FileType, ClaimDocumentTypes } from '../../services/e-claim/e-claim-types'
import ExerciseInfo from './ExerciseInfo'
import { useMemo } from 'react'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { setExerciseInfo } from '../../redux-store/exercise-reducer'
import config from '../../config'
import ExerciseForm from '../ExerciseDetail/ExerciseForm'
import colors from '../../constant/colors'

export type InitialValueType = {
  name: string
  amountReceipt: number
  amountClaim: number
  receiptFile: string
  optionalFileUrl: string
  relativeTypeId: string
  receiptDate: string
  claimName: string
}

const ExerciseHistoryDetail = () => {
  const { query } = useRouter<{ id: number }>()
  const history = useHistory()
  const dispatch = useDispatch()
  const { data: exerciseItem, isLoading } = useGetEClaimHistoryById({ id: query.id })
  const {
    claim,
    userClaimAmount,
    userClaimAmountApprove,
    relativeId,
    slipDate,
  } = exerciseItem || {}

  const receiptFile = useMemo(() => {
    if (!exerciseItem?.documentTypes) return ''

    return exerciseItem?.documentTypes?.filter(item => item.name === FileType.ReceiptFile)[0]?.files?.length > 0
      ? exerciseItem.documentTypes.filter(item => item.name === FileType.ReceiptFile)[0].files[0].name
      : ''
  }, [exerciseItem?.documentTypes])

  const optionalFileUrl = useMemo(() => {
    if (!exerciseItem?.documentTypes) return ''

    return exerciseItem?.documentTypes?.filter(item => item.name === FileType.OptionalFileUrl)[0]?.files?.length > 0
      ? exerciseItem.documentTypes.filter(item => item.name === FileType.OptionalFileUrl)[0].files[0].name
      : ''
  }, [exerciseItem?.documentTypes])

  const initialValue = useMemo(() => {
    return {
      name: claim?.name || '',
      amountReceipt: userClaimAmount,
      amountClaim: userClaimAmountApprove,
      receiptFile,
      optionalFileUrl,
      relativeTypeId: relativeId ? relativeId.toString() : '',
      receiptDate: slipDate,
      claimName: claim?.name || '',
    }
  }, [claim, userClaimAmount, userClaimAmountApprove, relativeId, slipDate, receiptFile, optionalFileUrl])

  const disable = useMemo(() => {
    if (!exerciseItem?.isApproved && (exerciseItem?.isApproved !== null)) {
      return false
    } else {
      return true
    }
  }, [exerciseItem?.isApproved])

  const onCreateNewExercise = useCallback(async () => {
    if (exerciseItem?.id === undefined) return

    dispatch(
      setExerciseInfo({
        name: exerciseItem.claim.name || '',
        amountReceipt: exerciseItem.userClaimAmount,
        amountClaim: exerciseItem.userClaimAmountApprove,
        receiptFile,
        optionalFileUrl,
        relativeTypeId: exerciseItem.relativeId ? exerciseItem.relativeId.toString() : '',
        receiptDate: exerciseItem.slipDate,
        claimName: exerciseItem.claim.name || '',
        receiptNo: exerciseItem?.receiptNo || '',
        workOutPlaceId: exerciseItem.workOutPlace?.id || 0,
        // remark: exerciseItem?.remark || '',
      }),
    )

    history.push(exerciseDetail({
      routeParam: {
        exerciseId: exerciseItem?.claimId
      },
      queryParam: {
        isCreateNew: 'true'
      }
    }))
  }, [exerciseItem, history, dispatch, receiptFile, optionalFileUrl])

  if (!exerciseItem || isLoading) return null

  return (
    <Loading loading={isLoading}>
      <div style={{ paddingTop: '24px' }}>
        <Headbar title={claim?.name || ''} backWard={paths.exerciseHistory()} titleColor={colors.BLACK} />
        <ExerciseInfo id={query.id} exerciseItem={exerciseItem} onCreateNewExercise={onCreateNewExercise} />
        <ExerciseForm
          exerciseItem={exerciseItem}
          exerciseId={exerciseItem.claimId}
          initialValues={initialValue}
          allpayStatus={disable}
          isHistory={true}
          editable={false}
        />
      </div>
    </Loading>
  )
}

export default ExerciseHistoryDetail